const RefreshIcon = ({ size = 16, fill = '#CE181E' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M9.99967 3.83344V2.34177C9.99967 1.96677 9.54967 1.78344 9.29134 2.05011L6.95801 4.37511C6.79134 4.54177 6.79134 4.80011 6.95801 4.96677L9.28301 7.29177C9.54967 7.55011 9.99967 7.36677 9.99967 6.99177V5.50011C12.758 5.50011 14.9997 7.74177 14.9997 10.5001C14.9997 11.1584 14.8747 11.8001 14.633 12.3751C14.508 12.6751 14.5997 13.0168 14.8247 13.2418C15.2497 13.6668 15.9663 13.5168 16.1913 12.9584C16.4997 12.2001 16.6663 11.3668 16.6663 10.5001C16.6663 6.81677 13.683 3.83344 9.99967 3.83344ZM9.99967 15.5001C7.24134 15.5001 4.99967 13.2584 4.99967 10.5001C4.99967 9.84177 5.12467 9.20011 5.36634 8.62511C5.49134 8.32511 5.39967 7.98344 5.17467 7.75844C4.74967 7.33344 4.03301 7.48344 3.80801 8.04177C3.49967 8.80011 3.33301 9.63344 3.33301 10.5001C3.33301 14.1834 6.31634 17.1668 9.99967 17.1668V18.6584C9.99967 19.0334 10.4497 19.2168 10.708 18.9501L13.033 16.6251C13.1997 16.4584 13.1997 16.2001 13.033 16.0334L10.708 13.7084C10.4497 13.4501 9.99967 13.6334 9.99967 14.0084V15.5001Z"
        fill={fill}
      />
    </svg>
  );
};

export default RefreshIcon;
